import React from "react";

import { Box, FormControlLabel, Radio, Typography } from "@mui/material";
import { makeStyles } from "tss-react/mui";

import { graphql } from "@/gql";
import { colors } from "@/theme/overrides/colors";
import { FragmentType } from "@/utils/type";

type UserListItemProps = {
  client?: FragmentType<typeof userListItemFragment> | null;
  useRadio: boolean;
  onSelect: () => void;
};

const useStyles = makeStyles()({
  container: {
    display: "flex",
    alignItems: "center",
    paddingLeft: 20,
    paddingRight: 20,
    paddingTop: 10,
    paddingBottom: 10,
    "&:hover": {
      backgroundColor: "#F5F5F5",
      cursor: "pointer",
    },
  },
  avatar: {
    width: 40,
    height: 40,
    borderRadius: 50,
    objectFit: "cover",
  },
  infoContainer: {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    marginLeft: 10,
  },
  name: {
    fontSize: 14,
    fontWeight: 600,
  },
  email: {
    color: colors.gray,
  },
});

const userListItemFragment = graphql(`
  fragment UserListItem on Client {
    id
    email
    profile {
      id
      fullName
      avatarUrl(variant: THUMB)
    }
  }
`);

const UserListItem: React.FC<UserListItemProps> = ({
  useRadio,
  client,
  onSelect,
}) => {
  const { classes } = useStyles();
  return (
    <Box className={classes.container} onClick={onSelect}>
      <img
        className={classes.avatar}
        src={client?.profile?.avatarUrl ?? ""}
        alt="avatar"
      />
      <Box className={classes.infoContainer}>
        <Typography variant="body2" className={classes.name}>
          {client?.profile?.fullName}
        </Typography>
        <Typography variant="caption" className={classes.email}>
          {client?.email}
        </Typography>
      </Box>
      {useRadio && (
        <FormControlLabel
          value={client?.id}
          control={<Radio color="primary" />}
          label=""
        />
      )}
    </Box>
  );
};

export default UserListItem;
